const jwt_customizer = {
    general: '定制JavaScript对象表示法（JSON）网络令牌（JWT）令牌时出错。请稍后再试。',
    can_not_create_for_admin_tenant: '无法为管理员租户创建JavaScript对象表示法（JSON）网络令牌（JWT）令牌定制器。',
};
export default Object.freeze(jwt_customizer);
